import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchSearchedCandidates } from "./CandidateSearchAPI"

const initialState = {
  data: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  loading: false,
  error: null,
}

export const fetchSearchedCandidatesAsync = createAsyncThunk(
  "SearchedCandidates/fetch",
  async (
    {
      notice_period,
      work_status,
      experience_min,
      experience_max,
      skills,
      locations,
      educations,
      candidate_gender,
      page = 1,
    },
    { rejectWithValue },
  ) => {
    try {
      const data = await fetchSearchedCandidates(
        notice_period,
        work_status,
        experience_min,
        experience_max,
        skills,
        locations,
        educations,
        candidate_gender,
        page,
      )

      return {
        candidates: data.response.data || [],
        pagination: {
          current_page: data.response.current_page || 1,
          last_page: data.response.last_page || 1,
          total: data.response.total || 0,
        },
      }
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const CandidateListSlice = createSlice({
  name: "Candidates",
  initialState,
  reducers: {
    resetSearchResults: (state) => {
      state.data = []
      state.pagination = {
        current_page: 1,
        last_page: 1,
        total: 0,
      }
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchedCandidatesAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSearchedCandidatesAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.candidates
        state.pagination = action.payload.pagination
        state.error = null
      })
      .addCase(fetchSearchedCandidatesAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || action.error.message
      })
  },
})

export const { resetSearchResults } = CandidateListSlice.actions
export const selectSearchedCandidates = (state) => state.searchedCandidates.data
export const selectSearchPagination = (state) => state.searchedCandidates.pagination
export const selectSearchLoading = (state) => state.searchedCandidates.loading

export default CandidateListSlice.reducer